import { render, staticRenderFns } from "./summary-table.vue?vue&type=template&id=36bf1ca2&scoped=true"
import script from "./summary-table.ts?vue&type=script&lang=ts&external"
export * from "./summary-table.ts?vue&type=script&lang=ts&external"
import style0 from "./summary-table.scss?vue&type=style&index=0&id=36bf1ca2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf1ca2",
  null
  
)

export default component.exports